import lodashDebounce from 'lodash-es/debounce';

export const DEFAULT_WAIT = 300;

/*
 * Wrapper around _.debounce to enforce our DEFAULT_WAIT
 */
export function debounce (func, wait = DEFAULT_WAIT, options = undefined) {
  return lodashDebounce(func, wait, options);
}
